import React from 'react';

export default function OAuthLoadingOverlay({ broker = 'broker' }) {
  // Debug logging removed to prevent infinite re-renders
  React.useEffect(() => {
    // Debug logging removed to prevent infinite re-renders
  }, [broker]);
  
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <div className="bg-zinc-900 rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl border border-zinc-800">
        <div className="flex flex-col items-center space-y-6">
          {/* Animated spinner */}
          <div className="relative">
            <div className="w-20 h-20 rounded-full border-4 border-purple-600/20 animate-pulse"></div>
            <div className="absolute top-0 left-0 w-20 h-20 rounded-full border-4 border-purple-600 border-t-transparent animate-spin"></div>
          </div>
          
          {/* Status text */}
          <div className="text-center space-y-2">
            <h2 className="text-2xl font-semibold text-white">
              Connecting to {broker}
            </h2>
            <p className="text-zinc-400 text-sm">
              Processing OAuth callback...
            </p>
          </div>
          
          {/* Progress steps */}
          <div className="w-full space-y-3 mt-4">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded-full bg-purple-600 flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="text-sm text-zinc-300">Authorization received</span>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded-full border-2 border-purple-600 flex items-center justify-center">
                <div className="w-3 h-3 rounded-full bg-purple-600 animate-pulse"></div>
              </div>
              <span className="text-sm text-zinc-300">Exchanging access tokens...</span>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded-full border-2 border-zinc-600 flex items-center justify-center">
                <div className="w-3 h-3 rounded-full bg-zinc-600"></div>
              </div>
              <span className="text-sm text-zinc-500">Fetching account details</span>
            </div>
          </div>
          
          {/* Security note */}
          <div className="mt-6 p-3 bg-zinc-800/50 rounded-lg w-full">
            <p className="text-xs text-zinc-400 text-center">
              🔒 Your credentials are encrypted and stored securely
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}